/**
 * The note, shown once in this browser, that the images a user sees carry a mark identifying their
 * account (PRT-10). The terms of use say so too; this keeps it in view where images are shown.
 */
import { useSyncExternalStore } from 'react'

import { readStored, writeStored } from './stored'

const KEY = 'pedfx.markNotice'
const listeners = new Set<() => void>()
let visible = false

// Storage blocked: the note shows again next time.
const seen = (): boolean => readStored(KEY) === 'seen'

const emit = () => listeners.forEach((listener) => listener())

/** A marked image arrived: show the note unless this browser has seen it. */
export function noticeMarks(): void {
  if (visible || seen()) return
  visible = true
  emit()
}

export function dismissMarkNotice(): void {
  visible = false
  writeStored(KEY, 'seen')
  emit()
}

export const markNoticeVisible = (): boolean => visible

export function useMarkNotice(): boolean {
  return useSyncExternalStore((listener) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  }, markNoticeVisible)
}
